import React from 'react'
import { Box, Typography } from '@mui/material'
import { IEntityPeriodTotals } from '../../../shared/services/contact-supplier/contact-supplier.model'
import { ISpendTotal } from '../../../shared/services/emission/emission.model'
import { formatGroupTotal, getGroupTotalTonnes } from '../../../shared/utils/group-total-utils'
import { formatSpendTotals } from '../../../shared/utils/spend-totals-utils'

// Cells for the period-total columns on entity lists (suppliers, projects). Both read figures the
// API attached to the row for the selected report period: emissions from the Analytics breakdown
// on the organisation's default Scope 2 basis, spend as entered per currency. An entity with
// nothing recorded in the period shows a dash rather than a zero.

const EMPTY = <Typography variant='body2' color='text.secondary'>–</Typography>

export const EmissionsTotalCell: React.FC<{ totals?: IEntityPeriodTotals; defaultMarketBased?: boolean }> = ({ totals, defaultMarketBased }) => {
  const tonnes = getGroupTotalTonnes(totals, defaultMarketBased)
  const label = tonnes && tonnes > 0 ? formatGroupTotal(tonnes) : null
  return (
    <Box sx={{ minWidth: 120, textAlign: 'right' }}>
      {label ? (
        <Typography variant='body2' sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{label}</Typography>
      ) : EMPTY}
    </Box>
  )
}

export const SpendTotalCell: React.FC<{ totals?: ISpendTotal[] }> = ({ totals }) => {
  const lines = formatSpendTotals(totals)
  return (
    <Box sx={{ minWidth: 120, textAlign: 'right' }}>
      {lines.length > 0 ? lines.map((line) => (
        <Typography key={line} variant='body2' sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{line}</Typography>
      )) : EMPTY}
    </Box>
  )
}
